import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/style_legal_pages.css";
import {formatPhoneFR} from "../utils/validators";
import { useGlobalProperty } from "../context/GlobalPropertyContext";

export default function Cookies() {
  const navigate = useNavigate();
  const { globalProperties, loading: globalLoading } = useGlobalProperty();

  return (
    <div className="legal-page">
      <div className="legal-container">
        <button className="legal-back-btn" onClick={() => navigate(-1)}><ion-icon name="arrow-back-outline"></ion-icon>Retour</button>

        <header className="legal-header">
          <h1>Gestion des Cookies</h1>
          <p className="legal-subtitle">Contrôlez vos préférences de cookies</p>
        </header>

        <article className="legal-content">
          
          <section className="legal-section">
            <h2>1. Qu'est-ce qu'un Cookie?</h2>
            <p>
              Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies permettent au site de mémoriser des informations sur vos préférences et votre comportement de navigation.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Types de Cookies Utilisés</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} utilise les types de cookies suivants :
            </p>
            
            <h3 className="legal-subsection">Cookies de Session</h3>
            <ul>
              <li>Stockés temporairement pendant votre visite</li>
              <li>Supprimés automatiquement à la fermeture du navigateur</li>
              <li>Permettent de maintenir votre connexion</li>
            </ul>

            <h3 className="legal-subsection">Cookies Persistants</h3>
            <ul>
              <li>Restent sur votre appareil après la fermeture du navigateur</li>
              <li>Remontent à votre prochaine visite</li>
              <li>Mémorisent vos préférences</li>
            </ul>

            <h3 className="legal-subsection">Cookies Essentiels</h3>
            <ul>
              <li>Nécessaires au fonctionnement du site</li>
              <li>Assurent votre sécurité</li>
              <li>Ne peuvent pas être désactivés</li>
            </ul>

            <h3 className="legal-subsection">Cookies Analytiques</h3>
            <ul>
              <li>Collectent des données anonymes sur votre utilisation du site</li>
              <li>Nous aident à améliorer le site</li>
              <li>Peuvent être refusés</li>
            </ul>

            <h3 className="legal-subsection">Cookies Marketing</h3>
            <ul>
              <li>Permettent de vous afficher des publicités pertinentes</li>
              <li>Suivi des campagnes marketing</li>
              <li>Peuvent être refusés</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Utilisation des Cookies</h2>
            <p>
              Les cookies sont utilisés pour :
            </p>
            <ul>
              <li><strong>Authentification :</strong> Vous maintenir connecté</li>
              <li><strong>Préférences :</strong> Mémoriser vos choix et paramètres</li>
              <li><strong>Sécurité :</strong> Prévenir la fraude et les accès non autorisés</li>
              <li><strong>Analyse :</strong> Analyser l'utilisation du site</li>
              <li><strong>Marketing :</strong> Afficher des publicités pertinentes</li>
              <li><strong>Panier :</strong> Stocker les articles du panier</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Contrôle des Cookies</h2>
            <p>
              Vous pouvez contrôler les cookies selon vos préférences :
            </p>
            
            <h3 className="legal-subsection">Dans votre Navigateur</h3>
            <ul>
              <li><strong>Chrome :</strong> Paramètres → Confidentialité et sécurité → Cookies</li>
              <li><strong>Firefox :</strong> Préférences → Confidentialité → Cookies</li>
              <li><strong>Safari :</strong> Préférences → Confidentialité → Gérer les données de site web</li>
              <li><strong>Edge :</strong> Paramètres → Confidentialité → Cookies</li>
            </ul>

            <h3 className="legal-subsection">Options de Contrôle</h3>
            <ul>
              <li>Autoriser tous les cookies</li>
              <li>Autoriser les cookies de session seulement</li>
              <li>Refuser tous les cookies</li>
              <li>Supprimer les cookies existants</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Cookies Tiers</h2>
            <p>
              Certains services tiers utilisent leurs propres cookies :
            </p>
            <ul>
              <li><strong>Google Analytics :</strong> Pour analyser l'utilisation du site</li>
              <li><strong>Réseaux Sociaux :</strong> Pour les boutons de partage</li>
              <li><strong>Processeurs de Paiement :</strong> Pour les transactions sécurisées</li>
            </ul>
            <p>
              Vous pouvez consulter les politiques de confidentialité de ces services pour contrôler leurs cookies.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Conséquences du Refus des Cookies</h2>
            <p>
              Si vous refusez les cookies non essentiels :
            </p>
            <ul>
              <li>Vous pouvez toujours naviguer sur le site</li>
              <li>Certaines fonctionnalités peuvent être limitées</li>
              <li>Vous devrez vous reconnecter à chaque visite</li>
              <li>Les recommandations personnalisées ne seront pas disponibles</li>
              <li>Les publicités ne seront pas ciblées</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Données Collectées par les Cookies</h2>
            <p>
              Les cookies peuvent collecter les informations suivantes :
            </p>
            <ul>
              <li>Adresse IP</li>
              <li>Type de navigateur et de système d'exploitation</li>
              <li>Pages visitées</li>
              <li>Heure de visite</li>
              <li>Durée de visite</li>
              <li>Produits consultés</li>
              <li>Informations de connexion</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>8. Sécurité des Cookies</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} met en place les mesures de sécurité suivantes :
            </p>
            <ul>
              <li>Chiffrement des données sensibles</li>
              <li>Accès restreint aux fichiers de cookies</li>
              <li>Suppression régulière des données obsolètes</li>
              <li>Conformité au RGPD</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>9. Mise à Jour de cette Politique</h2>
            <p>
              {globalProperties?.enterprise_info?.social_reason} peut mettre à jour cette politique des cookies à tout moment. Veuillez consulter cette page régulièrement pour les modifications.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Outils Pour Bloquer les Cookies</h2>
            <p>
              Plusieurs outils vous permettent de bloquer ou de gérer les cookies :
            </p>
            <ul>
              <li><strong>Do Not Track (DNT) :</strong> Signal envoyé aux sites pour demander de ne pas être suivi</li>
              <li><strong>Ghostery :</strong> Extension qui bloque les trackers</li>
              <li><strong>Privacy Badger :</strong> Extension qui protège votre vie privée</li>
              <li><strong>uBlock Origin :</strong> Bloqueur de publicités et de trackers</li>
            </ul>
          </section>

          <section className="legal-section last">
            <h2>11. Contact</h2>
            <p>
              Pour toute question concernant cette politique des cookies, veuillez nous contacter à :
            </p>
            <p>
              {globalProperties?.contacte?.email !== "" && <><strong>Email : </strong>{globalProperties?.contacte?.email || ""}<br /></>}
              {globalProperties?.contacte?.phone !== "" && <><strong>Téléphone : </strong>{formatPhoneFR(globalProperties?.contacte?.phone || "")}</>}
            </p>
            <p className="legal-date">
              <em>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</em>
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}